import { mapMessageToChatMessage } from '@/entities/interview-task';
import type { AIVisibleMessageV1 } from '@/shared/api';

export function mapReplayMessages(messages: AIVisibleMessageV1[]) {
	return messages.map((message) => {
		const mapped = mapMessageToChatMessage(message);
		return {
			...mapped,
			// Keep each attachment object tied to its original message, even when
			// successive submissions have the same file name.
			attaches: mapped.attaches?.map((file) =>
				file.kind === 'edit' ? { ...file, kind: 'view' as const } : file,
			),
		};
	});
}
